'use strict';

class AuthError extends Error {
    phone;
    constructor(params) {
        const { message = 'Auth Unknown error', phone } = params || {};
        super(message);
        this.phone = phone;
        // capturing the stack trace keeps the reference to your error class
        if (Error.captureStackTrace !== undefined) {
            Error.captureStackTrace(this, this.constructor);
        }
    }
}

exports.AuthError = AuthError;
//# sourceMappingURL=AuthError.js.map
